export default __webpack_public_path__ + "static/2-6d0fea6353a683894c164dff3a25862f.webp";